import React, {useEffect, useRef, useState} from 'react';
import {User} from '../functions/UserManagement';
import {useTranslation} from 'react-i18next';
import {useForm} from 'react-hook-form';
import Input from '../global/Input';
import IsoCodeSelectList from '../global/IsoCodeSelectList';
import {
    useExportDataToProjectMutation
} from '../../redux/rtk/injectedParcelApi';
import {showMessageOnError, showMessageOnSuccess} from '../global/CustomToast';
import {Parcel, Person} from '../functions/GlobalData';
import {getProject, getProjects, Project} from '../functions/Project';

type Props = {
    formId: string,
    projectId: string,
    mappingIdName: string
    selection: any[],
    onFinished: () => void
}
export const DataToProject = (props: Props): JSX.Element => {
    const {t} = useTranslation(['common', 'stammdaten']);

    const [exportDataToProject] = useExportDataToProjectMutation();
    const [data, setData] = useState<Parcel | undefined>(undefined);
    const [projects, setProjects] = useState<any[]>([]);
    const [selectedProject, setSelectedProject] = useState<string>('');

    const defaultValues = {
        'project_id': ''
        // 'flstkennz': '',
        // 'amtsgericht': '',
        // 'grundbuchbezirk': '',
        // 'gbbz': '',
        // 'blatt': '',
        // 'lfdnrbestandsvz': 0,
        // 'buchungsart': '',
        // 'b_land_iso': '',
        // 'zeitstempel': '',
        // 'kommentar': '',
        // 'ersteller': ''
    };

    const {control, formState: {errors}, handleSubmit, setValue, getValues, reset} = useForm({defaultValues});
    const saveData = (data: any) => {
        // eslint-disable-next-line camelcase
        setData(data);
    };

    const getFormErrorMessage = (name: string) => {
        // @ts-ignore
        return errors[name] && <small className="p-error custom">{errors[name].message}</small>;
    };

    useEffect(() => {
        getProjects().then((result) => {
            if (result && result.length) {
                setProjects(result.map((item: Project) => {
                    return {value: item.id, label: item.name};
                }));
            }
        });
    }, []);

    useEffect(() => {
        const aFunction = async () => {
            if (data) {
                let allOk = true;

                await exportDataToProject({
                    project_id: selectedProject,
                    [props.mappingIdName + 's']: props.selection.map((item: any) => {
                        return item[props.mappingIdName];
                    }),
                }).then(async (result: any) => {
                    if (result.error) {
                        allOk = false;
                    }
                });

                if (allOk) {
                    showMessageOnSuccess(t('globalData:global.addedToProject'), '');
                    props.onFinished();
                }
            }
        };
        aFunction();
    }, [data]);

    return (
        <form id={props.formId} onSubmit={handleSubmit(saveData)}>
            {/*<h4>{t('globalData:global.generalData')}</h4>*/}
            <div className={'h-full w-full'}>
                <Input
                    edit={true} label={t('project')} name={'project_id'}
                    type={'dropdown'} dropdownOptions={projects} value={selectedProject}
                    onChange={(e: any) => {
                        setSelectedProject(e.value);
                    }}
                    validationControl={control} validationErrorMessage={getFormErrorMessage}
                    validationRules={{
                        required: t('project') + ' ' + t('input:required')
                    }}
                />
            </div>
        </form>);
};
